/* Otulmama landing: delegacja zdarzen na dokumencie, kazda sekcja ograniczona swoim data-otl-section */
(function(){
  if(window.__otlInit) return; window.__otlInit = true;
  document.body.classList.add('otl-landing');
  function root(el){ return el.closest('[data-otl-section]'); }
  function money(cents){ return (cents/100).toFixed(2).replace('.', ',') + ' zł'; }
  function state(sec){
    if(!sec.__otl){
      var raw = sec.querySelector('script[data-otl-variants]');
      sec.__otl = { variants: raw ? JSON.parse(raw.textContent) : [], qty: 1 };
      var first = sec.querySelector('[data-otl-variant][aria-pressed=true]');
      sec.__otl.variantId = first ? Number(first.getAttribute('data-otl-variant')) : (sec.__otl.variants[0] && sec.__otl.variants[0].id);
    }
    return sec.__otl;
  }
  function setMain(sec, src, srcset, alt){
    var main = sec.querySelector('[data-otl-main]'); if(!main || !src) return;
    main.src = src; if(srcset) main.srcset = srcset; if(alt) main.alt = alt;
  }
  function updatePrice(sec){
    var s = state(sec), v = s.variants.find(function(x){ return x.id === s.variantId; }); if(!v) return;
    var total = s.qty === 3 ? v.price * 2 : v.price;
    sec.querySelectorAll('[data-otl-price]').forEach(function(el){ el.textContent = money(total); });
  }
  document.addEventListener('click', function(e){
    var vbtn = e.target.closest('[data-otl-variant]');
    if(vbtn){
      var sec = root(vbtn); if(!sec) return; var s = state(sec);
      s.variantId = Number(vbtn.getAttribute('data-otl-variant'));
      sec.querySelectorAll('[data-otl-variant]').forEach(function(b){ b.setAttribute('aria-pressed', b === vbtn ? 'true' : 'false'); });
      var label = sec.querySelector('[data-otl-variant-name]'); if(label) label.textContent = vbtn.getAttribute('data-name');
      setMain(sec, vbtn.getAttribute('data-img'), vbtn.getAttribute('data-srcset'), vbtn.getAttribute('data-name'));
      updatePrice(sec); return;
    }
    var thumb = e.target.closest('[data-otl-thumb]');
    if(thumb){
      var sec2 = root(thumb); if(!sec2) return;
      sec2.querySelectorAll('[data-otl-thumb]').forEach(function(b){ b.setAttribute('aria-current', b === thumb ? 'true' : 'false'); });
      setMain(sec2, thumb.getAttribute('data-img'), thumb.getAttribute('data-srcset'), thumb.getAttribute('data-alt'));
      return;
    }
    var atc = e.target.closest('[data-otl-atc]');
    if(atc){
      e.preventDefault();
      var sec3 = document.querySelector('[data-otl-section][data-otl-hero]'); if(!sec3) return;
      var s3 = state(sec3); var msg = sec3.querySelector('[data-otl-msg]');
      document.querySelectorAll('[data-otl-atc]').forEach(function(b){ b.disabled = true; });
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: s3.variantId, quantity: s3.qty }] })
      }).then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
        .then(function(){ window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; })
        .catch(function(){ if(msg) msg.textContent = 'Nie udało się dodać do koszyka. Spróbuj jeszcze raz.'; document.querySelectorAll('[data-otl-atc]').forEach(function(b){ b.disabled = false; }); });
    }
  });
  document.addEventListener('change', function(e){
    var q = e.target.closest('[data-otl-qty]'); if(!q) return;
    var sec = root(q); if(!sec) return; state(sec).qty = Number(q.value); updatePrice(sec);
  });
  function sticky(){
    var bar = document.querySelector('[data-otl-sticky]'); var target = document.querySelector('[data-otl-hero] [data-otl-atc]');
    if(!bar || !target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function(entries){ entries.forEach(function(en){ bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); }); }).observe(target);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sticky); else sticky();
})();
